export default __webpack_public_path__ + "static/media/tfg-dropdown.14287850.webp";